import { render, staticRenderFns } from "./WizardChart.vue?vue&type=template&id=588b4289&scoped=true"
import script from "./WizardChart.vue?vue&type=script&lang=js"
export * from "./WizardChart.vue?vue&type=script&lang=js"
import style0 from "./WizardChart.vue?vue&type=style&index=0&id=588b4289&scoped=true&lang=css"
import style1 from "./WizardChart.vue?vue&type=style&index=1&id=588b4289&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b4289",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588b4289')) {
      api.createRecord('588b4289', component.options)
    } else {
      api.reload('588b4289', component.options)
    }
    module.hot.accept("./WizardChart.vue?vue&type=template&id=588b4289&scoped=true", function () {
      api.rerender('588b4289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/WizardChart.vue"
export default component.exports